export default "__VITE_ASSET__3a813012__"